import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { ROLE_LABEL } from "./UsersTab";

export const AccountTab = () => {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [pin, setPin] = useState({ current: "", new_pin: "" });
  const [busy, setBusy] = useState(false);

  const savePin = async (e) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(pin.new_pin)) return toast.error("PIN must be exactly 4 digits");
    setBusy(true);
    try {
      await api.post("/auth/change-pin", pin);
      toast.success("PIN changed");
      setPin({ current: "", new_pin: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", f);
      toast.success("Password changed");
      setF({ current_password: "", new_password: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="account-tab">
      <div className="panel p-4">
        <p className="font-semibold" data-testid="account-name">{user?.name}</p>
        <p className="text-sm text-muted-foreground">{[user?.email, user?.mobile].filter(Boolean).join(" · ")}</p>
        <span className="chip mt-2 border-border" data-testid="account-role">{ROLE_LABEL[user?.role]}</span>
      </div>
      {user?.mobile && (
        <form onSubmit={savePin} className="panel space-y-4 p-4" data-testid="change-pin-form">
          <h3 className="font-heading font-bold">{user.has_pin ? "Change PIN" : "Set a PIN for mobile login"}</h3>
          <div><label className="label">Current PIN or password</label>
            <input type="password" className="field" required value={pin.current} onChange={(e) => setPin({ ...pin, current: e.target.value })} data-testid="current-pin-input" /></div>
          <div><label className="label">New 4-digit PIN</label>
            <input type="password" className="field mono tracking-[0.5em]" inputMode="numeric" maxLength={4} required value={pin.new_pin} onChange={(e) => setPin({ ...pin, new_pin: e.target.value.replace(/\D/g, "") })} data-testid="new-pin-input" /></div>
          <button className="btn btn-primary w-full" disabled={busy} data-testid="change-pin-btn">Update PIN</button>
        </form>
      )}
      <form onSubmit={submit} className="panel space-y-4 p-4">
        <h3 className="font-heading font-bold">Change password</h3>
        <div><label className="label">Current password (or PIN)</label>
          <input type="password" className="field" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password-input" /></div>
        <div><label className="label">New password (min 6)</label>
          <input type="password" className="field" required minLength={6} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password-input" /></div>
        <button className="btn btn-primary w-full" disabled={busy} data-testid="change-password-btn">{busy && <Loader2 size={18} className="animate-spin" />} Update password</button>
      </form>
    </div>
  );
};
